import { Carxteam, Ingeprop, Opesnfac, Taskgraf } from "./Graphics";
import Teincome from "./Graphics/Teincome";

/**
 * Componente para seleccionar la grafica a pintar
 */
export function Graphsel({
  graphName,
  graphComponent,
  MODIDXXX,
  PROIDXXX,
  graphKeyName,
  filtersFieldsGraph
}) {
  const properties = {
    graphName,
    MODIDXXX,
    PROIDXXX,
    graphKeyName,
    filtersFieldsGraph,
  };

  const types = {
    Taskgraf: <Taskgraf {...properties} />,
    Carxteam: <Carxteam {...properties} />,
    Ingeprop: <Ingeprop {...properties} />,
    Opesnfac: <Opesnfac {...properties} />,
    Teincome: <Teincome {...properties} />,
  };

  return <>{types[graphComponent]}</>;
}
